import { EnhancedCard } from 'components/enhanced/card/EnhancedCard';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { useRef } from 'react';
import { productWarehouseHistoryService } from 'features/inventory/warehouses/api/product-warehouse-history.service';
import { WarehouseProductsHistoryLineColumns } from 'features/settings/history/product-warehouse-history-line';

interface ITabProductWarehouseHistoryLinkParams {
  input_params: Record<string, any>;
}

function ProductWarehouseHistoryLinkTabTable(params: ITabProductWarehouseHistoryLinkParams) {
  const { input_params } = params;

  const historyRefresh = useRef(null);

  // -------------------------------------------------------------- OPERATIONS
  const columnsHistoryLink = WarehouseProductsHistoryLineColumns(historyRefresh);

  return (
    <>
      <EnhancedCard>
        <EnhancedDataGrid
          columns={columnsHistoryLink}
          service={productWarehouseHistoryService}
          outerParams={input_params}
          refresh={historyRefresh}
        />
      </EnhancedCard>
    </>
  );
}

export default ProductWarehouseHistoryLinkTabTable;
